import { BaseModel } from 'ag-common-lib/lib/models/base.model';

export enum ConferenceLogBulkInviteeOutcomeStatusKeys {
  conferenceDbId = 'conferenceDbId',
  previousOutcomeStatus = 'previousOutcomeStatus',
  newOutcomeStatus = 'newOutcomeStatus',
  registrantDbIds = 'registrantDbIds',
  wasabiPath = 'wasabiPath',
}

export class ConferenceLogBulkInviteeOutcomeStatus extends BaseModel {
  [ConferenceLogBulkInviteeOutcomeStatusKeys.conferenceDbId]: string;
  [ConferenceLogBulkInviteeOutcomeStatusKeys.previousOutcomeStatus]: string | null;
  [ConferenceLogBulkInviteeOutcomeStatusKeys.newOutcomeStatus]: string;
  [ConferenceLogBulkInviteeOutcomeStatusKeys.registrantDbIds]: string[];
  [ConferenceLogBulkInviteeOutcomeStatusKeys.wasabiPath]: string;
}
